/** @file Which project cards need a thumbnail render: live projects whose thumbnail is missing or older. */
import type { ProjectListItem } from '../../api/apiTypes';

/** Ids in list order, at most `limit`; a missing thumbRev (an older Worker) counts as none. */
export function staleThumbnails(items: readonly ProjectListItem[], limit: number): string[] {
  return items.filter((p) => p.trashedAt === null && (p.thumbRev ?? -1) < p.rev).slice(0, limit).map((p) => p.id);
}
